import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	DEFAULT_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
	FRAME_MEDIUM_GREY,
	TRANSPARENT_COLOR,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame25 = (props: TQrFrameProps) => {
	const { previewMode } = props

	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const frameColor = isNormalFrameMode(props) ? props.frameColor : FRAME_BLACK
	const textColor = isNormalFrameMode(props) ? props.textColor : 'white'
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: TRANSPARENT_COLOR

	const getTextY = (fontSize: number) => {
		const boxTop = 68
		const boxHeight = 13
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				id="frame-background"
				d="M3 13h57v56H3z"
				fill={frameBackgroundColor}
			/>
			<path
				id="frame"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M62 78.561C62.02 79.9 60.936 81 59.62 81H4.4C3.063 81 2 79.899 2 78.561V13.4A2.4 2.4 0 0 1 4.4 11h55.22c1.316 0 2.4 1.084 2.38 2.4zM59.62 68V13.4H4.4V68z"
				fill={frameColor}
			/>
			<path
				id="shadow"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.458 6.955h4.644A3.97 3.97 0 0 1 32.068 3a3.97 3.97 0 0 1 3.967 3.955h4.644a4.11 4.11 0 0 1 4.101 4.111v2.948a.785.785 0 0 1-.793.795H20.15a.785.785 0 0 1-.794-.795v-2.948a4.11 4.11 0 0 1 4.102-4.11m10.178.02c0 .867-.702 1.57-1.567 1.57a1.57 1.57 0 0 1-1.567-1.57 1.568 1.568 0 1 1 3.134 0"
				fill={previewMode ? FRAME_MEDIUM_GREY : frameColor}
			/>
			{!previewMode ? (
				<path
					id="shadow"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M23.458 6.955h4.644A3.97 3.97 0 0 1 32.068 3a3.97 3.97 0 0 1 3.967 3.955h4.644a4.11 4.11 0 0 1 4.101 4.111v2.948a.785.785 0 0 1-.793.795H20.15a.785.785 0 0 1-.794-.795v-2.948a4.11 4.11 0 0 1 4.102-4.11m10.178.02c0 .867-.702 1.57-1.567 1.57a1.57 1.57 0 0 1-1.567-1.57 1.568 1.568 0 1 1 3.134 0"
					fill={previewMode ? FRAME_MEDIUM_GREY : 'white'}
					opacity={previewMode ? 1 : 0.5}
				/>
			) : null}
			<rect
				id="qr-background"
				x={8}
				y={17}
				width={48}
				height={48}
				rx={2}
				fill={qrBackgroundColor}
			/>
			{qrMarkup ? (
				<g
					dangerouslySetInnerHTML={{
						__html: flattenNestedSvg(qrMarkup, {
							x: 15,
							y: 24,
							width: 34,
							height: 34,
						}),
					}}
				/>
			) : (
				<MockQr x={15} y={24} width={34} height={34} />
			)}
			<FrameText
				text={props.text}
				fontSize={props.fontSize}
				textColor={textColor}
				textY={getTextY(props.fontSize)}
				fontFamily={DEFAULT_FRAME_FONT}
			/>
		</svg>
	)
}
